export const TODAY = "Today";
export const ZERO = 0;
export const ELEVEN = 11;
export const CLEAR_ANNOUNCEMENT_TIMEOUT = 500;
export const CALENDAR_LIVE_REGION_ID = "calendar-live-region";
export const WEEKDAYS = [0, 1, 2, 3, 4, 5, 6];
export const WEEKDAYS_LONG = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
export const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];